export default __webpack_public_path__ + "static/media/Resource-Icons-Gross-Motor-transparent.fe685a51.png";